<template lang="pug">
  .component-create-entity-button
    .row.card
      .column
        label Group Name
          input(type="text", v-model="group.name")
        .row
          .column
            label Policies
              SelectizePolicy(:selectedValues="group.policies", :maxItems="null", @optionSelected="updatePolicies", @optionRemoved="removePolicies")
          .column
            input(type="checkbox", v-model="group.global")
            label Add all Drivers
            label(v-show="!group.global") Drivers
              SelectizeDriver(@optionSelected="updateDrivers", @optionRemoved="removeDrivers", :maxItems="null" ref="selectizeDrivers")
        .row(v-if="group.id !== null && !group.global")
          .column(v-if="loaded")
            base-list(:component="componentDriver", :dataLoader="loadDrivers",  componentType="groupList", v-model="selected", :selectableList="true", :resultsPerPage="5")
        ActionButton(slot="footer", :action="save", :disabled="group.name == null || group.name === ''") Save
        button.button.alert.float-right(slot="footer", @click="$refs[componentId].close()") Cancel
</template>

<script>
  import ModalReveal from '../../components/structure/foundation/ModalReveal'
  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import MaggieHelper from '../../maggieHelper'
  import ActionButton from '../../components/structure/ui/ActionButton'
  import SelectizePolicy from '../../components/structure/ui/lists/selectize/SelectizePolicy'
  import SelectizeDriver from '../../components/structure/ui/lists/selectize/SelectizeDriver'
  import BaseList from './BaseList'

  export default {
    name: 'GroupEdit',
    components: {BaseList, SelectizeDriver, SelectizePolicy, ActionButton, ModalReveal},
    data() {
      return {
        componentDriver: require('src/components/backoffice/Driver.vue'),
        selected: [],
        loaded: false,
        group: {
          id: null,
          global: false,
          name: null,
          drivers: [],
          policies: [],
        }
      }
    },
    created() {
      if (this.item !== null) {
        for (let key in this.item) {
          this.group[key] = this.item[key]
        }

        this.loadDrivers((data) => {
          this.selected = data.items.map((item) => {
            return '' + item.id
          })
        }, 1, -1)
      }
    },
    methods: {
      updatePolicies(val) {
        this.group.policies.push(val)
      },
      removePolicies(val) {
        const policy = this.group.policies.findIndex((item) => {
          return item.id === val.id
        })

        this.group.policies.splice(policy, 1)
      },
      updateDrivers(val) {

        const position = this.selected.indexOf('' + val.id)
        if (position !== -1) {
          this.selected.splice(position, 1)
        } else {
          this.selected.push('' + val.id)
        }
      },
      removeDrivers(val) {
        const position = this.selected.indexOf('' + val.id)
        this.selected.splice(position, 1)
      },
      save() {
        let body = this.group
        if (this.group.global === false) {
          body.drivers = this.selected
        }

        body.policies = this.group.policies.map((item) => {
          return item.id == null ? item : item.id
        })


        if (this.group.id === null) {
          return KeplerBackofficeSdk.groups.make(body, (data) => {
            MaggieHelper.notification('Group', 'group created')
            this.$router.push({name: 'groups'})
          })
        }

        return KeplerBackofficeSdk.groups.select(this.group.id).edit(body, (data) => {
          MaggieHelper.notification('Group', 'group updated')
          this.$router.push({name: 'groups'})
        })
      },
      loadDrivers(callback, page, resultsPerPage) {
        KeplerBackofficeSdk.groups.select(this.group.id).drivers(page, resultsPerPage, (data) => {
          callback(data)
          this.loaded = true
        })
      },
    },
    computed: {
      componentId() {
        return this.groupProp !== null ? `groupReveal-${this.groupProp.id}` : `groupReveal-${this._uid}`
      },
    },
    props: {
      groupProp: {
        type: Object,
        default: null
      },
      item: {
        type: Object,
        default: null
      },

    }
  }
</script>

<style lang="sass">
  //.list-items
    background: rebeccapurple !important
    height: 300px
    overflow-x: scroll
</style>



// WEBPACK FOOTER //
// GroupEdit.vue?6b2a04d6